export enum BigImageFormFields {
  maskType = 'maskType',
  image = 'image'
}
